<template>
  <el-tabs tab-position="bottom">
      <el-tab-pane label="校园环境">
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="banner in banners2" :key="banner.index" :autoplay="false">
          <el-image :src="banner.url"></el-image>
        </el-carousel-item>
      </el-carousel>
    </el-tab-pane>
    <el-tab-pane label="教学环境">
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="banner in banners1" :key="banner.index" :autoplay="false">
          <el-image :src="banner.url"></el-image>
        </el-carousel-item>
      </el-carousel>
    </el-tab-pane>
  
  </el-tabs>
</template>

<script>
export default {
  data() {
    return {
      banners1: [
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/j1.jpg",
          to: ""
        },
         {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/j2.jpg",
          to: ""
        },
         {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/j3.jpg",
          to: ""
        },
         {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/j4.jpg",
          to: ""  
        },

      ],
       banners2: [
      {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/x1.jpg",
          to: ""
        },
         {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/x2.jpg",
          to: ""
        },
         {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/x3.jpg",
          to: ""
        },
         {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/x4.jpg",
          to: ""
        },
      ]
    };
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-tabs__nav {
  margin-left: 44%;
}
/deep/ .el-tabs__item {
  font-size: 15px;
  font-weight: 600;
}
/deep/ .el-tabs__item:hover {
  color: #000;
}
/deep/ .el-tabs__item.is-active {
  color: #000;
}
/deep/ .el-tabs__active-bar {
  height: 3px;
  background-color: #000;
}
/deep/ .el-tabs__item {
  color: #838383;
//   height: 53px;
//   line-height: 53px;
  padding: 0 10px;
}
</style>